import { IServidor } from "@/interfaces/IServidor";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "..";

interface ServidorState {
  items: IServidor[];
  synced: boolean;
}

const initialState: ServidorState = {
  items: [],
  synced: false,
};

const servidorSlice = createSlice({
  name: "SERVIDOR",
  initialState,
  reducers: {
    sync: (state, action: PayloadAction<{ items: IServidor[] }>) => {
      state.items = action.payload.items;
      state.synced = true;
    },
  },
});

export default servidorSlice.reducer;

export const getServidoresSynced = (state: RootState) => state.servidor.items;
